
import React  from "react";
import { Container , Col ,Row } from "reactstrap";
import  './Nftcards.css';
import { Link } from "react-router-dom";
import Liveaction from "../Live-Action/Liveaction";
import { useState } from "react";
import Modal from "../Modal/Modal";
import { faL } from "@fortawesome/free-solid-svg-icons";

function  Nftcards  (props) {


    const {title , id  , currentBid,  creatorImg , imgUrl , creator  } = props.item;
    console.log(props.item);

    const [showModal , setShowModal]  =  useState(false);



    return( 
        <div className="single__nft__card">
                <div className="nft__img">
                    <img  src={imgUrl} className="w-100"  />
                </div>

                <div className="nft__content">
                    <h5  className="nft__title"> <Link  to={`/market/${id}`} > {title}  </Link>  </h5>
                    <div className="creator__info-wrapper  d-flex gap-3">
                        <div className="creator__img">
                            <img  src={creatorImg}   className="w-100"/>
                        </div>

                        <div className="creator__info  w-100  d-flex  align-items-center  justify-content-between  ">
                            <div  className="">
                                <h6> Created By </h6>
                                <p> {creator} </p>
                            </div>

                            <div  className="">
                                <h6> Current Bid </h6>
                                <p> {currentBid} </p>
                            </div>
                        </div>
                    </div>

                    <div className="mt-3  d-flex align-items-center  justify-content-between">
                        <button className="bid__btn gap-2 "  onClick={()=>
                                setShowModal(true)
                            }>
                            <i style={{marginRight:"5px"}} className="ri-shopping-bag-line"></i>
                            Place Bid 
                        </button>


                        {
                            showModal && <Modal  setShowModal={setShowModal} /> 
                        }


                        <span  className="history__link"> 
                            <Link to='#' >  
                                View History 
                            </Link> 
                        </span>
                    </div>
                </div>
        </div>
    );
}


export default Nftcards;



